<template>
  <div v-if="name">
    {{ name }}
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';

export default {
  props: {
    list: {
      type: String,
      required: true,
    },
    id: {
      required: true,
    }
  },
  computed: {
    name() {
      const getter = `veevaVault/${this.list}`
      const obj = find(this.$store.getters[getter], p => p.id === this.id);
      return obj ? obj.name__v : null;
    },
  }
}
</script>
